import { Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'store';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as XLSX from 'xlsx';
import { openSnackbar } from 'store/slices/snackbar';
import { useIntl } from 'react-intl';

const DownloadReportsHealth = ({ dataToDownload }: any) => {
    const intl = useIntl();
    const dispatch = useDispatch();

    const { loading } = useSelector((state) => state.healthContent);

    const downloadReport = () => {
        const workbook = XLSX.utils.book_new();

        const metricsFair = dataToDownload.metricFair
            ? dataToDownload.metricFair.filter((item: any) => item !== null)
            : dataToDownload.metricsFair.filter((item: any) => item !== null);
        const metricsGood = dataToDownload.metricGood
            ? dataToDownload.metricGood.filter((item: any) => item !== null)
            : dataToDownload.metricsGood.filter((item: any) => item !== null);
        const metricsPoor = dataToDownload.metricPoor
            ? dataToDownload.metricPoor.filter((item: any) => item !== null)
            : dataToDownload.metricsPoor.filter((item: any) => item !== null);
        const resumes = dataToDownload.resume
            ? dataToDownload.resume.filter((item: any) => item !== null)
            : dataToDownload.resumeProducts.filter((item: any) => item !== null);

        const metricFair = XLSX.utils.json_to_sheet(metricsFair || [{}]);
        XLSX.utils.book_append_sheet(workbook, metricFair, 'Metric Fair');

        const metricGood = XLSX.utils.json_to_sheet(metricsGood || [{}]);
        XLSX.utils.book_append_sheet(workbook, metricGood, 'Metric Good');

        const metricPoor = XLSX.utils.json_to_sheet(metricsPoor || [{}]);
        XLSX.utils.book_append_sheet(workbook, metricPoor, 'Metric Poor');

        const resume = XLSX.utils.json_to_sheet(resumes || [{}]);
        XLSX.utils.book_append_sheet(workbook, resume, 'Resume');

        XLSX.writeFile(workbook, 'healthContent.xlsx');

        dispatch(
            openSnackbar({
                message: `${intl.formatMessage({ id: 'download_successfully' })}`,
                variant: 'success'
            })
        );
    };

    return (
        <Button
            startIcon={<FileDownloadIcon />}
            onClick={downloadReport}
            color="primary"
            variant="outlined"
            component="label"
            size="large"
            sx={{ zIndex: 1000 }}
            disabled={loading}
        >
            <Typography>Download</Typography>
        </Button>
    );
};
export default DownloadReportsHealth;
